const get = require('lodash.get');

function UserService($http, $state, ConfigEnvironment, Subscriber, ApiService) {
  "ngInject";

  this.resetPass = function (params) {
    return $http({
      url: ConfigEnvironment.getConfiguration('greenback') + 'reset-password',
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: params,
      transformRequest: function(obj) {
        var str = [];
        for (var p in obj)
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        return str.join("&");
      },
      params: {
        access_token: params.access_token || 'tokenauth'
      }
    });
  }

  this.register = function (registration, successHandler, errorCb) {

    if(registration.referred_by) {
      registration.referred_by.realm = "greenback_join_process";
    }

    const defaultErrorMsg = 'There was an issue registering the account with the information provided. Please try again later and feel free to contact support.';

    const errStatusMsgs = {
      default: defaultErrorMsg,
      422: 'It appears that the email address you entered is associated to an existing account Please use a different email or login below.'
    };

    return Subscriber.create({
      "first_name": registration.first_name,
      "last_name": registration.last_name,
      "email": registration.username,
      "password": registration.password,
      "referred_by": registration.referred_by || null
    }).$promise.then((data) => {
      //response doesn't mean success
      if(data.error) {
        ApiService.errorHandler(data, errStatusMsgs, errorCb);
      }
      else if(!data.id) {
        ApiService.errorHandler(new Error(`Response did not return an id. ${JSON.stringify(data)}`), errStatusMsgs, errorCb);
      }
      else {
        successHandler(data);
      }
    }).catch((data) => {
      const errMsg = get(data, 'data.error.message', "");
      if (errMsg.includes("INVALID_DOMAIN")) {
        errStatusMsgs[422] = "Please provide an email address with a valid domain name.";
      }
      ApiService.errorHandler(data, errStatusMsgs, errorCb);
    });
  }

  this.processReconvention = function(params, errMsgCb, successCb) {

    const errMsg = "There was a problem verifying your account. If the error persists, select Report Error and let us help you resolve the issue!";

    const errStatusMsgs = {
      400: `${errMsg} (400)`,
      404: `${errMsg} (404)`,
    };

    Subscriber.reconvene({
      "sid": params.subscriber_id,
      "token": params.verificationToken
    }).$promise.then((response) => {
      if(response.data && response.data.error) {
        ApiService.errorHandler(response, errStatusMsgs, errMsgCb);
      } else {
        successCb(response.subscriber);
      }
    }).catch((err) => {
      ApiService.errorHandler(err, errStatusMsgs, errMsgCb);
    });
  }

  this.confirmDeletion = function(params, errMsgCb, successCb) {

    const errMsg = "There was a problem deleting your account. If the error persists, select Report Error and let us help you resolve the issue!";

    const errStatusMsgs = {
      400: `${errMsg} The token was either invalid or expired. (400)`,
      404: `${errMsg} (404)`,
      226: `This subscriber has already been deleted`,
    };

    Subscriber.confirmDeletion({
      "uid": params.subscriber_id,
      "token": params.deletionToken
    }).$promise.then((response) => {
      if(response.data && response.data.error) {
        ApiService.errorHandler(response, errStatusMsgs, errMsgCb);
      } else {
        successCb(response.subscriber);
      }
    }).catch((err) => {
      ApiService.errorHandler(err, errStatusMsgs, errMsgCb);
    });
  }

}

export default UserService;



// WEBPACK FOOTER //
// ./js/containers/users/services/user.service.js